var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWishList(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 13,
    viewBox: "0 0 14 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.8894 1.21893C12.1647 0.432907 11.1702 0 10.0891 0C9.28096 0 8.54086 0.255493 7.88931 0.759323C7.56055 1.01364 7.26265 1.32478 7 1.68794C6.73746 1.32489 6.43945 1.01364 6.11058 0.759323C5.45914 0.255493 4.71904 0 3.9109 0C2.82976 0 1.83524 0.432907 1.11052 1.21893C0.394455 1.99577 0 3.05705 0 4.20741C0 5.39142 0.441238 6.47523 1.38855 7.61833C2.23599 8.64084 3.45396 9.67883 4.86441 10.8808C5.34602 11.2913 5.89194 11.7565 6.45879 12.2521C6.60854 12.3833 6.80069 12.4555 7 12.4555C7.1992 12.4555 7.39146 12.3833 7.541 12.2523C8.10785 11.7566 8.65408 11.2912 9.13591 10.8805C10.5461 9.67873 11.7641 8.64084 12.6116 7.61823C13.5589 6.47523 14 5.39142 14 4.20731C14 3.05705 13.6055 1.99577 12.8894 1.21893Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWishList);
export default __webpack_public_path__ + "static/media/WishList.bcfcea60779eda6e0801ccc961c06a30.svg";
export { ForwardRef as ReactComponent };